// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mh-1";
export var messageSideRight = "_mh-2";
export var subscribeToBackInStockBubbleContainer = "_mh-0";